import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { publicApi } from "@/lib/api";

const MonturesContext = createContext(null);

export function MonturesProvider({ children }) {
    const [data, setData] = useState({
        items: [],
        loading: true,
        error: null,
    });

    const refresh = useCallback(async () => {
        setData((d) => ({ ...d, loading: true, error: null }));
        try {
            const items = await publicApi.listMontures();
            setData({ items, loading: false, error: null });
        } catch (e) {
            setData({ items: [], loading: false, error: e.message });
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    return (
        <MonturesContext.Provider
            value={{
                items: data.items,
                loading: data.loading,
                error: data.error,
                refresh,
                coupDeCoeur: data.items.find((m) => m.coupDeCoeur) || null,
                duMoment: data.items.filter((m) => m.moment),
            }}
        >
            {children}
        </MonturesContext.Provider>
    );
}

export function useMontures() {
    const ctx = useContext(MonturesContext);
    if (!ctx) throw new Error("useMontures must be used within MonturesProvider");
    return ctx;
}
